<template>
    <div>
        <card-toolbar>
            <!-- Search before create, deliberately: reaching for the directory
                 first is what stops it filling up with duplicate restaurants. -->
            <button @click="openPicker"><i class="fas fa-search mr-2"/>Attach Contact</button>
            <button @click="openNew"><i class="fas fa-plus mr-2"/>New Contact</button>
        </card-toolbar>
        <card-list>
            <contact-list-item
                :card="card"
                :contact="contact"
                v-for="contact in contacts"
                :key="contact.link_id"
                :active="isActive(contact)"
                @click="openEdit(contact)"
            />
            <container-list-item padded v-if="!contacts.length">
                <p class="has-text-grey is-size-7 my-2">No contacts.</p>
            </container-list-item>
        </card-list>
    </div>
</template>

<script>
    import {client as http} from '../http_client';
    import CardToolbar from "../TIER/components/CardToolbar";
    import CardList from "../TIER/components/CardList";
    import ContainerListItem from "../TIER/components/ContainerListItem";
    import ContactListItem from "@/components/ContactListItem";

    /**
     * The Contacts tab of an entity card.
     *
     * Unlike notes, there is no LEGACY map here: the per-entity contact_*
     * column blocks this replaces are retired at the cutover rather than kept
     * as a second door, so every entity type goes through one API.
     *
     * Clicking a row edits the LINK (role, label, notes for this attachment),
     * not the directory record -- that keeps someone annotating one booking
     * from rewriting a contact shared across three trips. The link card has a
     * button through to the directory record for when that IS the intent.
     */
    export default {
        name: 'EntityContactsPane',
        components: {ContactListItem, ContainerListItem, CardList, CardToolbar},
        props: ['card', 'child', 'entityType', 'entityId'],
        data: function () {
            return {
                contacts: []
            }
        },
        methods: {
            openPicker: function () {
                this.$openCard('pick-contact', {entityType: this.entityType, entityId: this.entityId}, this.card);
            },
            openNew: function () {
                this.$openCard('new-contact', {entityType: this.entityType, entityId: this.entityId}, this.card);
            },
            openEdit: function (contact) {
                this.$openCard('edit-entity-contact', {linkId: contact.link_id}, this.card);
            },
            isActive: function (contact) {
                return !!(this.child && this.child.definition.component === 'edit-entity-contact'
                    && String(this.child.props.linkId) === String(contact.link_id));
            },
            loadContacts: function (force) {
                if (!this.entityId) return;
                http.get(`/api/contacts/entity/${this.entityType}/${this.entityId}`, {force}).then(response => {
                    this.contacts = response.data;
                    this.$emit('count', this.contacts.length);
                });
            },
            reload: function () {
                this.loadContacts(true);
            }
        },
        watch: {
            entityId: function () {
                this.loadContacts(true);
            },
            // When a child card (pick / new / edit) closes or changes, the list
            // is likely stale -- panes live inside the host card, so they can't
            // be targeted by $reloadCard like standalone cards.
            child: function () {
                this.loadContacts(true);
            }
        },
        mounted() {
            this.loadContacts();
        }
    };
</script>
